import React from "react";

interface Props {
  height?: number;
  width?: number;
}

const Padding = ({ height = 0, width = 0 }: Props) => (
  <div>
    <style jsx>{`
      div {
        height: ${height}px;
        width: ${width}px;
      }
    `}</style>
  </div>
);

export default Padding;
